import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../../../../common'
import type { Expression } from '../../expression'
import type * as expressionNode from '../../node'
import type { FnHelper } from '../helper'
import { Key } from '../key'
import * as fnNode from '../node'

import {
  CommonArgs,
  removeIsolatedValueNodes,
  standardNodeCreator,
} from './utils'

/**
 * TODO ({ key: string; value: any }[] -> object)
 *
 * @param todo TODO
 * @example
 * TODO
 * // ->
 * TODO
 */
export interface LessThan<out T = any> {
  /** {@link LessThan} */
  readonly [Key.LessThan]: T extends boolean
    ? readonly Expression<any>[]
    : never
}
export namespace LessThan {
  export const isLessThan: TypeChecker<LessThan> = TypeChecker.Factory.lazy(
    () =>
      TypeChecker.Factory.object<LessThan>({
        [Key.LessThan]: CommonArgs.isListOfExpressions,
      }),
  ).usingAlias('Fn.LessThan')
  export const assertIsLessThan: TypeAsserter<LessThan> =
    TypeAsserter.Factory.from(isLessThan)

  /**
   * @see {@link Node}
   */
  export class Node<T extends boolean = boolean> extends fnNode.Node<
    T,
    Key.LessThan,
    readonly expressionNode.Node[]
  > {
    public readonly type = common.value.types.Intrinsic.Boolean

    constructor(arg: Node<T>['arg']) {
      super(Key.LessThan, arg)
    }
  }
  export namespace Node {
    export const isNode: TypeChecker<Node> = TypeChecker.Factory.instance(Node)
    export const assertIsNode: TypeAsserter<Node> =
      TypeAsserter.Factory.from(isNode)
  }

  const expressionsInArgs: FnHelper<LessThan>['expressionsInArgs'] = fn =>
    fn[Key.LessThan]
  export const HELPER: FnHelper<LessThan> = {
    createNode: standardNodeCreator.comparison({
      compare: (a, b) => a < b,
      getArgExpressions: expressionsInArgs,
      nodeClass: Node,
    }),
    expressionsInArgs,
    typeChecker: isLessThan,
  }
}
